import * as React from "react";
const SvgIcPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 12H19M12 5L12 19", strokeWidth: 2, strokeLinecap: "round", stroke: "currentColor" }));
export default SvgIcPlus;
